import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Chart.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class PartnerBatchBooking extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static fillUp({ all_bookings = false, batch_bookings = [], organizationId, partnerId }) {
        return fetcher.post(`/ticket/organizations/${organizationId}/partners/${partnerId}/fill-up`, {
            data: {
                all_bookings,
                batch_bookings
            }
        });
    }

    fillUp({ organizationId, partnerId }) {
        return this.constructor.fillUp({
            organizationId,
            partnerId,
            batch_bookings: [this.pk]
        });
    }

    freeRemainingBookings({ organizationId, partnerId, rates }) {
        let rate_ids = rates.map(r => {
            return r.id;
        });
        return fetcher.post(`/ticket/organizations/${organizationId}/partners/${partnerId}/batches/actions`, {
            data: {
                type: 'async_free_remaining_bookings',
                ids: [parseInt(this.id)],
                rates_ids: rate_ids
            }
        });
    }

    static listUrl({ organizationId, partnerId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Partner] organizationId is mandatory');
        }
        if (!partnerId) {
            throw new ArgumentError('[Model][Partner] partnerId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/partners/${partnerId}/batches`;
    }
}
